<template>
  <div>
    <To :to="data.to" @updateTo="data.to = $event"></To>
    <FormInput label="Phone Number" :value="data.phone_number" hint="9988345423" @update="data.phone_number = $event"></FormInput>
    <FormInput label="First Name" :value="data.first_name" hint="John" @update="data.first_name = $event"></FormInput>
    <FormInput label="Last Name" :value="data.last_name" hint="Doe" @update="data.last_name = $event"></FormInput>
    <ReplyMarkup :reply_markup="data.reply_markup" :actions="actions" @changeReplyMarkup="data.reply_markup = $event"></ReplyMarkup>
  </div>
</template>


<script>
import ReplyMarkup from '@/components/tasks/fields/ReplyMarkup.vue'
import To from '@/components/tasks/fields/To.vue'
import FormInput from '@/components/tasks/fields/FormInput.vue'



export default {
  name: 'SendContact',
  components:{
    ReplyMarkup,
    To,
    FormInput
  },
  props: {
    data: Object,
    actions: Object
  },
  methods:{
  },


}
</script>
